module.exports = __webpack_public_path__ + "static/media/pincel-preto.86084601.png";